import { render, staticRenderFns } from "./ImageNewsTwo.vue?vue&type=template&id=e41af380&scoped=true"
import script from "./ImageNewsTwo.vue?vue&type=script&lang=js"
export * from "./ImageNewsTwo.vue?vue&type=script&lang=js"
import style0 from "./ImageNewsTwo.vue?vue&type=style&index=0&id=e41af380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41af380",
  null
  
)

export default component.exports